import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/layout/Sidebar";
import CalendarPopup from "../../components/layout/CalendarPopup";

export default function AuthenticatedRoot() {

  return (
    <>
      <Box mb={10}>
        <CalendarPopup />
        <Sidebar>
          <Outlet />
        </Sidebar>
      </Box>
    </>
  );
}